import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Image, Form, Input, message, Modal, Space, InputNumber, Card, Option, Select, Row, Col } from "antd";
import { EditOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";

import { useSelector, useDispatch } from "react-redux";
import UploadFile from "../../components/UploadFile";
import { LocalImage } from "../../components/ImageUtil";
import { fileManagerActions } from "../../store";
import modulesApi from "../../api/module/modulesApi";
import productApi from "../../api/product/productApi";
import { Editor } from "@tinymce/tinymce-react";
import parse from "html-react-parser";

const dataExample = {
  title: null,
  product: null,
  productName: null,
  description: null,
  ingredients: null,
  use: null,
  image: null,
};
const cleanHTMLTags = (htmlString) => {
  // Sử dụng regex để loại bỏ thẻ HTML
  const cleanString = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
  return cleanString;
};

const Product = (props) => {
  const { Option } = Select;

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const [loading, setLoading] = useState(false);
  const [isModalEditContractVisible, setIsModalEditContractVisible] = useState(false);

  const [valueFormData, setValueFormData] = useState(dataExample);

  const [bannerData, setBannerData] = useState(dataExample);
  const [productName, setProductName] = useState("");
  const [des, setDes] = useState("");
  const [ingredient, SetIngredient] = useState("");
  const [uses, SetUses] = useState("");

  const { fileImageUrl } = useSelector((x) => x.fileManager);
  const [products, setProducts] = useState([]);

  const productNameRef = useRef(null);
  const desRef = useRef(null);
  const ingredientRef = useRef(null);
  const usesRef = useRef(null);

  useEffect(() => {
    form.setFieldsValue(valueFormData);
  }, [form, valueFormData]);

  useEffect(() => {
    getProduct();
    getHomeFeaturedProduct();
  }, []);

  const getHomeFeaturedProduct = () => {
    setLoading(true);
    modulesApi
      .getHomeFeaturedProduct()
      .then((res) => {
        if (res?.values !== null) {
          const data = res?.values;
          setBannerData({
            ...data,
            productName: parse(data.productName),
            description: parse(data.description),
            use: parse(data.use),
            ingredients: parse(data.ingredients),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getProduct = () => {
    const params = {
      published: true,
      page: 1,
      limit: 10000,
    };
    productApi.getProducts(params).then((res) => {
      if (res) {
        const data = res?.results.map((item) => {
          return { text: item.name, value: item.id };
        });
        setProducts(data);
      }
    });
  };

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const showEditModal = () => {
    setImageNull(bannerData.image);
    setProductName(bannerData?.productName);
    setDes(bannerData?.description);
    SetIngredient(bannerData?.ingredients);
    SetUses(bannerData?.use);

    setValueFormData({
      title: bannerData.title,
      product: bannerData.product?.id || null,
    });
    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    if (fileImageUrl !== null) {
      if (productNameRef.current.getContent() || "") {
        updateBanner({ ...values, image: fileImageUrl });
      } else {
        Swal.fire({
          title: "Thất bại!",
          text: "Vui lòng nhập tên sản phẩm!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng tải ảnh lên!",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  const updateBanner = (data) => {
    setLoading(true);
    let _productName = "";
    let _des = "";
    let _ingredient = "";
    let _uses = "";

    if (productNameRef.current) {
      _productName = productNameRef.current.getContent() || "";
    }

    if (desRef.current) {
      _des = desRef.current.getContent() || "";
    }

    if (ingredientRef.current) {
      _ingredient = ingredientRef.current.getContent() || "";
    }

    if (usesRef.current) {
      _uses = usesRef.current.getContent() || "";
    }

    const payload = {
      "home-featured-product": {
        title: data.title,
        product: data.product,
        productName: _productName,
        description: _des,
        ingredients: _ingredient,
        use: _uses,
        image: data.image,
      },
    };

    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa banner thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getHomeFeaturedProduct();
          setIsModalEditContractVisible(false);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const closePopup = useCallback(() => {
    setValueFormData({});
    form.resetFields();
    setIsModalEditContractVisible(false);
  }, [form]);

  return (
    <>
      <div className="tabled">
        <Space size={10}>
          <Button type="dashed" onClick={() => showEditModal()} size="small">
            <EditOutlined /> &nbsp; Sửa sản phẩm
          </Button>
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <Row>
            <Col span={4}></Col>
            <Col span={14}>
              <div className="recommend-large">
                <Row gutter={[24, 2]} align="center">
                  <Col span={10}>
                    <div style={{ padding: 14, marginTop: 25 }}>
                      <LocalImage src={bannerData.image} className="recommend-large__img" />
                    </div>
                  </Col>
                  <Col span={12}>
                    <p className="recommend-large__text">{bannerData.title}</p>
                    <div
                      className="recommend-large__product"
                      dangerouslySetInnerHTML={{
                        __html: bannerData?.productName,
                      }}
                    ></div>
                    <div>
                      <p
                        className="recommend-large__product-desc"
                        dangerouslySetInnerHTML={{
                          __html: bannerData?.description,
                        }}
                      ></p>
                    </div>
                    <Row gutter={[24, 0]}>
                      <Col span={12}>
                        <h4 className="recommend-large__product-element">Thành Phần</h4>
                        <p
                          className="recommend-large__product-element-desc"
                          dangerouslySetInnerHTML={{
                            __html: bannerData?.ingredients,
                          }}
                        ></p>{" "}
                        <br />
                        <span className="btn btn-primary recommend-large__product-btn">Xem chi tiết</span>
                        <br />
                        <br /> <br />
                      </Col>
                      <Col span={12}>
                        <h4 className="recommend-large__product-uses">Công dụng</h4>
                        <p
                          className="recommend-large__product-uses-desc"
                          dangerouslySetInnerHTML={{
                            __html: bannerData?.use,
                          }}
                        ></p>{" "}
                        <br />
                        <span className="btn btn-blue recommend-large__product-btn s-none">Thêm vào giỏ hàng</span>
                        <br /> <br />
                        <br />
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col span={12}>
                        <span className="btn btn-primary recommend-large__product-btn">
                          Xem chi tiết
                        </span>
                      </Col>
                      <Col span={12}>
                        <span className="btn btn-blue recommend-large__product-btn s-none">
                          Thêm vào giỏ hàng
                        </span>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span={4}></Col>
          </Row>
          <br />
          <br />
        </Card>
        <Modal
          title="Sửa banner"
          visible={isModalEditContractVisible}
          size="large"
          width={1000}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
          style={{
            top: 25,
          }}
        >
          <div>
            <Form initialValues={valueFormData} form={form} name="basic" layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off">
              <Row gutter={[24, 0]}>
                <Col span={12}>
                  <Form.Item
                    label="Tiêu đề"
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập tiêu đề!",
                      },
                    ]}
                  >
                    <Input placeholder="Nhập tiêu đề..." />
                  </Form.Item>

                  <Form.Item
                    label="Sản phẩm"
                    name="product"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn!",
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      showSearch
                      size="large"
                      placeholder="Chọn sản phẩm..."
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {products == null || products === "undefined"
                        ? []
                        : products.map((item, key) => (
                            <Option key={key} value={item.value}>
                              {item.text}
                            </Option>
                          ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label="Tên sản phẩm">
                    <Editor
                      tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
                      onInit={(evt, editor) => (productNameRef.current = editor)}
                      initialValue={productName}
                      init={{
                        height: 150,
                        menubar: false,
                        language: "vi",
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                        ],
                        toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "removeformat | help",
                        content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                      }}
                    />
                  </Form.Item>

                  <Form.Item label="Mô tả">
                    <Editor
                      tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
                      onInit={(evt, editor) => (desRef.current = editor)}
                      initialValue={des}
                      init={{
                        height: 200,
                        menubar: false,
                        language: "vi",
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                        ],
                        toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "removeformat | help",
                        content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Thành phần">
                    <Editor
                      tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
                      onInit={(evt, editor) => (ingredientRef.current = editor)}
                      initialValue={ingredient}
                      init={{
                        height: 220,
                        menubar: false,
                        language: "vi",
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                        ],
                        toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "removeformat | help",
                        content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="Công dụng">
                    <Editor
                      tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
                      onInit={(evt, editor) => (usesRef.current = editor)}
                      initialValue={uses}
                      init={{
                        height: 220,
                        menubar: false,
                        language: "vi",
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                        ],
                        toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "removeformat | help",
                        content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                      }}
                    />
                  </Form.Item>

                  <Form.Item label="Ảnh hiển thị">
                    <UploadFile />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Product;
